"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var Checkbox_1 = require("./Checkbox");
var StringManipulater_1 = require("Utils/StringManipulater");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var dynamic_1 = require("@vanilla-extract/dynamic");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var BASE_CLASS_NAME = "dashboard-selectall";
var SelectAllCheckbox = (function (_super) {
    __extends(SelectAllCheckbox, _super);
    function SelectAllCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCheckboxClicked = function () {
            var _a, _b, _c;
            if (_this.props.toggleClick) {
                _this.props.toggleClick();
                return;
            }
            if (_this.props.selectionState === Checkbox_1.CheckboxState.All) {
                (_a = _this.selectionStore) === null || _a === void 0 ? void 0 : _a.deselectAll();
            }
            else {
                (_b = _this.selectionStore) === null || _b === void 0 ? void 0 : _b.selectAll();
            }
            (_c = _this.dashboardViewStore) === null || _c === void 0 ? void 0 : _c.closeProjectActionMenu();
        };
        _this.selectionStore = props.selectionStore;
        _this.dashboardViewStore = props.dashboardViewStore;
        return _this;
    }
    SelectAllCheckbox.prototype.render = function () {
        var _a;
        var isSelectionEmpty = this.props.numSelectedProjects === 0;
        var _b = this.props, onMouseDown = _b.onMouseDown, resourceLabel = _b.resourceLabel;
        var numResource = (0, StringManipulater_1.pluralise)(this.props.numSelectedProjects, resourceLabel);
        var textToDisplay = this.props.selectionState === Checkbox_1.CheckboxState.None ? "Select all" : "".concat(numResource, " selected");
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME, onMouseDown: onMouseDown },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s", direction: "horizontal", style: isSelectionEmpty ? (0, dynamic_1.assignInlineVars)((_a = {}, _a[tokens_1.tokens.color.text] = tokens_1.tokens.color.textSecondary, _a)) : undefined },
                react_1.default.createElement(kaleidoscope_1.Checkbox, { id: "select-all", size: "m", label: textToDisplay, tooltip: {
                        content: this.props.selectionState === Checkbox_1.CheckboxState.All ? "Unselect all" : "Select all",
                        position: kaleidoscope_1.TooltipPosition.Bottom,
                    }, onChange: this.toggleCheckboxClicked, checked: checkedState.get(this.props.selectionState) || false }))));
    };
    SelectAllCheckbox = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SelectAllCheckbox);
    return SelectAllCheckbox;
}(react_1.default.Component));
exports.default = SelectAllCheckbox;
var checkedState = new Map([
    [Checkbox_1.CheckboxState.All, true],
    [Checkbox_1.CheckboxState.None, false],
    [Checkbox_1.CheckboxState.Some, "mixed"],
]);
